// extracted by mini-css-extract-plugin
export default {"main":"Chess_main__vm1Hg","footer":"Chess_footer__BfLk8"};